// JS file for ArticleItem

import u from '@main';
import '@vendor/pdfjs-dist/build/pdf.js?99141f134376ef9b3794c167';
import '@vendor/pdfjs-dist/build/pdf.worker.js?99141f134376ef9b3794c167';
import '@vendor/swiper/swiper-bundle.min.js?99141f134376ef9b3794c167';

// 這邊手動為子層有 iframe 的 p 增加一個影片專用的 className
$('.c-graduate-item__content iframe').parent('p').addClass('iframe-wrapper');

// @see：https://ithelp.ithome.com.tw/articles/10280083
const url = u.data('url');
const flipbook = $('#js-flipbook');
const ebookProgress = $('#js-ebook-progress');
const ebookInput = $('.ebook-input');
const nextBtn = $('.c-nav-button--next');
const prevBtn = $('.c-nav-button--prev');
const backWardBtn = $('.ebook-backward-btn');
const loading = $('.j-progress-loading');
const loadingInner = $('.j-progress-inner');
const scale = 1;
const ebookIframe = $('#ebook-iframe');
let pageRenderCount = 0;
let flipbookParent = $('.js-flipbook-parent');
let viewportProportion = 0;
let singleProportion = 0;
let maxHeight = 0;

window.onload = function () {
  if (url !== null && window.innerWidth >= 768) {
    getPdf(url);
  }

  if (window.innerWidth < 768) {
    ebookIframe.attr('src' , u.data('iframeUrl'));
    prepareIframeView();
  }
};

window.addEventListener('resize', () => {
  if (window.innerWidth < 768) {
    prepareIframeView();
  } else {
    flipbook.css('width', '');
    flipbook.css('height', '');

    let parentWidth = flipbookParent.width();

    parentWidth = parentWidth / 2;

    $(flipbook).turn('size', parentWidth, parentWidth / singleProportion);
  }
});

function getPdf(url) {
  const pdfjsLib = window['pdfjs-dist/build/pdf'];

  pdfjsLib.GlobalWorkerOptions.workerSrc = window['pdfjs-dist/build/pdf.worker'];

  const loadingTask = pdfjsLib.getDocument(
    {
      url: url,
      disableAutoFetch: true,
      disableStream: true,
    }
  );

  loadingTask.promise.then(async function (pdf) {
    //根據總頁數新增固定的div和canvas
    prepareFlipBook(pdf).then(async function () {
      await flipbookParent.addClass('active');

      await $(flipbook).turn({
        autoCenter: false,
        acceleration: true,
        display: 'double',
        when: {
          turning: function (event, page, pageObj) {
            ebookProgress.val(page);
            ebookInput.attr('placeholder', '目前在第' + page + '頁');
          }
        },
      });

      await loading.hide();
    });
  });
}

function prepareIframeView() {
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const aspectRatio = windowWidth / (windowHeight - 100);
  const iframeWidth = ebookIframe.width();
  const iframeHeight = iframeWidth / aspectRatio;

  ebookIframe.height(iframeHeight);
}

async function prepareFlipBook(pdf) {
  ebookProgress.attr('max', pdf.numPages);
  ebookInput.attr('max', pdf.numPages);

  for (let i = 1; i <= pdf.numPages; i++) {
    let id = 'canvaspage' + i;
    let div = document.createElement('div');
    let canvas = $(`<canvas id="${id}"></canvas>`)[0];
    div.appendChild(canvas);

    await setCanvas(i, pdf, canvas, div).then(async function () {
      await loadingInner.width(((i / pdf.numPages) * 100) + '%');
    });
  }
}

//將pdf新增到canvas裡面
async function setCanvas(i, pdf, canvas, pageElement) {
  const page = await pdf.getPage(i);

  const viewport = page.getViewport({ scale: scale });

  const context = canvas.getContext('2d');

  canvas.height = viewport.height;
  canvas.width = viewport.width;

  // viewport 的比例
  viewportProportion = viewport.height / viewport.width;
  let flipbookWidth = loading.width() / 2;

  const flipbookHeight = flipbookWidth * viewportProportion;

  if (maxHeight < flipbookHeight) {
    maxHeight = flipbookHeight;

    singleProportion = flipbookWidth / maxHeight;
  }

  // flipbook 高度計算
  flipbook.height(maxHeight);

  // Render PDF page into canvas context
  const renderContext = {
    canvasContext: context,
    viewport: viewport
  };

  const r = await page.render(renderContext);

  // Wait current page loading
  await r.promise;

  // 清空記憶體
  page.cleanup();

  pageRenderCount++;

  flipbook.append(pageElement);
}

prevBtn.on('click', () => {
  flipbook.turn('previous');
});

nextBtn.on('click', () => {
  flipbook.turn('next');
});

backWardBtn.on('click', () => {
  flipbook.turn('page', 1);
});

ebookInput.on('change', () => {
  const val = ebookInput.val();
  flipbook.turn('page', val);
});

ebookProgress.on('change', () => {
  const val = ebookProgress.val();
  flipbook.turn('page', val);
});
